import constants from "../../resource/constants"

export const AthenaGlobalHeader = () => (
  <cbw-header
    app-id={constants.app_id}
    site-title="AP"
    program-type="k-12"
    skip-target-id="main"
    use-icon-logo="true"
    use-search-widget="false"
    use-login-widget={true}
    destination-url={window.location}
  />
)

export const AthenaGlobalFooter = () => (
    <cbw-footer
      show-back-to-top-link={true}
    />
  )
